export interface Offers {
  budget: number,
  city: string,
  comment_phm: string,
  company_name: string,
  cond_offer: number,
  cond_delivery: number,
  cond_payment: number,
  country: string,
  delivery_remarks?: string,
  description: string,
  employee_leader: 0,
  employee_phm: 0,
  for_pdf?: number,
  name_project: string,
  offer_date: string,
  offer_id: 0,
  offer_salutation: string,
  offer_firstname: string,
  offer_lastname: string,
  order_id: 0,
  person_delivery?: string,
  postcode: string,
  project_id: string,
  request_id: 0,
  status: string,
  street: string,
  specification: string,
  vat_id: string,
}

export interface OffersList {
  budget: number,
  comment_phm: string,
  controlling_nr: string,
  delivery_date: string,
  description: string,
  for_pdf?: number,
  heat_nr: string,
  material: string,
  name: string,
  number_of_pieces: number,
  offer_id: string,
  part?: number,
  position: number,
  project_id: string,
  purchasing_price: number,
  remarks: string,
  selling_price: number,
  serial_nr: string,
  side_agreements?: string,
  specification: string,
  status: string,
  taric?: string,
  technical_drawing: string,
  technology: boolean,
  weight: string,
}

export class SingleOffer {
  budget: number = 0;
  city: string = '';
  comment_phm: string = '';
  company_name: string = '';
  cond_offer: number = 0;
  cond_delivery: number = 0;
  cond_payment: number = 0;
  country: string = '';
  delivery_remarks?: string = '';
  description: string = '';
  employee_leader: number = 0;
  employee_phm: number = 0;
  for_pdf?: number = 0;
  name_project: string = '';
  offer_date: string = '';
  offer_id: number = 0;
  offer_salutation: string = '';
  offer_firstname: string = '';
  offer_lastname: string = '';
  order_id: number = 0;
  postcode: string = '';
  project_id: string = '';
  request_id: number = 0;
  status: string = '';
  street: string = '';
  specification: string = '';
  vat_id: string = '';
}

export interface OfferPDF {
  for_pdf: boolean,
  offer_id: number,
  part: number,
  position: number,
  project_id: string
}

export interface OfferSteps {
  stepI: StepI;
  stepII: StepII;
  stepIII: StepIII;
  stepIV: StepIV;
}

class StepI {
  project_id: string = '';
  offer_id: number = 0;
  company_name: string = '';
  street: string = '';
  postcode: string = '';
  city: string = '';
  country: string = '';
  name_project: string = '';
  description: string = '';
  offer_date: string = '';
  request_id: string = '';
  order_id: string = '';
  vat_id: string = '';
  status: string = '';
  budget: number = 0;
}

class StepII {
  employee_phm: string = '';
}

class StepIII {
  employee_leader: string = '';
}

class StepIV {
  cond_offer: number = 0;
  cond_payment: number = 0;
  cond_delivery: number = 0;
  delivery_remarks: string = '';
}
